import { prefetchModelIndex } from '@rhino-project/core/hooks';
import { ModelIndexPage } from '@rhino-project/ui-heroui';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/$owner/reports/')({
  loader: ({ context: { rhino } }) => {
    return prefetchModelIndex(rhino, 'report');
  },
  component: RouteComponent
});

function RouteComponent() {
  return <ModelIndexPage model="report" syncUrl />;
}
